import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';


export default function PhpackagingmaterialListTableHeader(){
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
            <Grid item lg={6} xs={4} ><Typography variant="h5"> Title </Typography></Grid>
            <Grid item lg={3} xs={4} ><Typography variant="h5"> Product Form </Typography></Grid>
                        
                        {/* <Grid item lg={1} xs={1} ><Typography variant="h5"> Business Id </Typography></Grid> */}

      </Grid>
      
    )
}